import React from 'react';
import TextMessage from './text-message';

export default function ImageMessage({ message = {} }) {
  return (
    <div className="w-full">
      {message.url && (
        <a href={message.url} target="_blank" rel="noopener noreferrer">
          <img
            src={message.url}
            alt={message.caption || ''}
            loading="lazy"
            className="max-h-80 max-w-full rounded-xl border border-hairline object-contain"
          />
        </a>
      )}
      {message.caption && (
        <div className="mt-2">
          <TextMessage message={message.caption} />
        </div>
      )}
    </div>
  );
}
